import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {apiCall} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
class TicketDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tickets:[],
      isLoad:true,
      loading:false,
      ticketFormData : {
        title:'',
        description:'',
      }
    }
  }
  componentDidMount() {
    this.getCustomerInfo();
  }
  getCustomerInfo = async () =>{
    const id = this.props.match.params.id;
    try {
      const response = await apiCall('business/tickets/info/'+id,'get',null);
      this.setState({tickets: response});
      const updatedData = {...this.state.ticketFormData};
      Object.keys(updatedData).forEach(key => {
            updatedData[key]=response[key] === undefined ? "" : response[key]
      })
      this.setState({ ticketFormData: updatedData,isLoad:false }, () => {});
    }catch (e) {
      this.setState({ isLoad:false })
    }
  }
  handleChance = (e) => {
    const {name,value} = e.target;
    this.setState(prevState => ({
      ticketFormData : {
        ...prevState.ticketFormData,
        [name] : value
      }
    }))
  }
  handleTicketSubmit = async (e) => {
    e.preventDefault();
    this.setState({loading:true});

    try {
      const response = await apiCall('business/tickets/update/'+this.state.tickets.id,'post',{title: this.state.ticketFormData.title,description: this.state.ticketFormData.description});
      this.setState({loading:false});
      mainHelper.toastMessage(response.status,response.message)
    }catch (e) {
      this.setState({loading:false});
    }

  }
  render() {
    const {loading} = this.state;
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{display: this.state.isLoad ? 'block' : 'none'}}>
            <div className="loader" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid"/>
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"/>
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Destek talebi detayları"
                Breadcrumb={[
                  {name: "Destek Talepleri", navigate: "tickets"},
                  {name: "Detay", navigate: ""},
                ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">

                  <form onSubmit={this.handleTicketSubmit}>
                    <div className="body text-center">
                      <h6>Detaylar</h6>
                      <div className="row clearfix justify-content-center">
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                                name="title"
                                id="title"
                                className="form-control"
                                placeholder="Başlık"
                                type="text"
                                value={this.state.ticketFormData.title}
                                onChange={this.handleChance}
                            />
                          </div>
                          <div className="form-group">
                            <textarea
                                name="description"
                                id="description"
                                className="form-control"
                                placeholder="Açıklama"
                                value={this.state.ticketFormData.description}
                                onChange={this.handleChance}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="body">
                        <div className="row clearfix justify-content-center">
                          <div className="col-lg-6 col-md-12">
                            {loading ? (
                                    <button className="btn btn-outline-primary btn-block"
                                            disabled={true}
                                            style={{textAlign: "-webkit-center"}}>
                                      Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                                                                      height={'24px'}
                                                                      color="#268bd2"></ReactLoading>
                                    </button>
                                ) :
                                <button
                                        className="btn btn-outline-primary btn-block"
                                        type="submit">
                                  Güncelle
                                </button>}

                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ioTReducer}) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(TicketDetail)));
